import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { ASK_PHASES } from '../../../../constants/aiAnalytics';
import { AI_COLORS } from '../aiAnalyticsConstants';

import AskStatusIndicator from './AskStatusIndicator';

export default function AskProgress({ phase, reasoning }) {
  const showLongRunHint = phase === ASK_PHASES.EXECUTING;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          backgroundColor: AI_COLORS.surfaceMuted,
          borderRadius: '12px 12px 12px 0',
          px: 2,
          py: 1.5,
          maxWidth: '85%',
          width: '100%'
        }}
      >
        <AskStatusIndicator phase={phase} />

        {showLongRunHint && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.75 }}>
            Large analytics queries can take a few minutes. You can leave this page — the result will be saved to this
            conversation and appear here when it is ready.
          </Typography>
        )}

        {reasoning && (
          <Accordion sx={{ mt: 1 }} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle2">Reasoning</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {reasoning}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Box>
  );
}
